{
  "eyebrow": "C'est parti",
  "title": "Bienvenue chez Done-it, {{company}}.",
  "sub": "Votre essai de 30 jours de {{plan}} est actif. Trois choses à faire ensuite.",
  "next1": {
    "title": "Téléchargez l'application mobile",
    "desc": "Envoyez le lien d'installation à votre équipe par SMS ou e-mail.",
    "cta": "Envoyer le lien d'invitation"
  },
  "next2": {
    "title": "Invitez votre équipe",
    "desc": "Importez les employés en masse depuis un CSV ou ajoutez-les un par un.",
    "cta": "Ouvrir l'administration"
  },
  "next3": {
    "title": "Regardez une démo de 4 minutes",
    "desc": "Découvrez comment configurer votre premier projet et vos lieux.",
    "cta": "Regarder la vidéo"
  },
  "cta": "Aller au tableau de bord",
  "receipt": "Un reçu et un e-mail d'accueil sont en route vers {{email}}.",
  "fallbacks": {
    "company": "votre entreprise",
    "plan": "votre formule",
    "inbox": "votre boîte mail"
  },
  "stores": {
    "appStore": "App Store",
    "googlePlay": "Google Play"
  },
  "subFree": "Votre compte {{plan}} est actif — gratuit pour toujours. Trois choses à faire ensuite."
}
